/* CreditUsageBar — "X of Y credits used, resets {date}" with a bar, plus
 * "+ Z top-up credits (expire {date})" when the user has bought any.
 *
 * Numbers come from GET /api/billing/status via useCredits, never from the local
 * plan constants, so a trial's reduced allowance and the server's real limit
 * always show correctly. Nothing is ever shown below 0. Hidden for guests (they
 * use a separate question limit) and until the first fetch lands.
 *
 * Shown on the iOS app too: it is information, not a purchase. No emoji.
 */

import useCredits from '../hooks/useCredits'
import { V2, V2Bar } from './JaiV2'
import { JAI_FONTS } from './JaiBrand'

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString('en-US', { day: 'numeric', month: 'long' }) } catch { return '' }
}

export default function CreditUsageBar({ compact = false, style = {} }) {
  const credits = useCredits()
  if (!credits || credits.limit == null) return null

  const used = Math.min(credits.used, credits.limit)
  const pct = credits.limit ? (used / credits.limit) * 100 : 0
  const nextExpiry = credits.topups?.[0]?.expiresAt
  const reset = fmtDate(credits.resetAt)

  return (
    <div style={{ fontFamily: JAI_FONTS.tight, ...style }}>
      <div style={{ fontSize: compact ? 11.5 : 12.5, color: V2.mute, display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
        <span>
          <strong style={{ color: V2.navy }}>{used} of {credits.limit}</strong> credits used{reset ? `, resets ${reset}` : ''}
        </span>
        {credits.topupCredits > 0 && (
          <span>
            + {credits.topupCredits} top-up credit{credits.topupCredits === 1 ? '' : 's'}
            {nextExpiry ? ` (expire ${fmtDate(nextExpiry)})` : ''}
          </span>
        )}
      </div>
      <div style={{ marginTop: 5 }}>
        <V2Bar value={pct} tone={pct >= 90 ? 'weak' : 'strong'} height={compact ? 5 : 7} />
      </div>
    </div>
  )
}
